import React from 'react'
import IconSignIn from 'material-ui/svg-icons/action/assignment-ind'
import IconHome from 'material-ui/svg-icons/action/home'
import IconPeople from 'material-ui/svg-icons/social/people'
import IconTaxi from 'material-ui/svg-icons/maps/local-taxi'
import IconSettings from 'material-ui/svg-icons/action/settings'
import IconAnnouncement from 'material-ui/svg-icons/action/speaker-notes'
import IconBooking from 'material-ui/svg-icons/communication/contact-phone'
import IconWheelLock from 'material-ui/svg-icons/notification/vpn-lock'
import IconText from 'material-ui/svg-icons/editor/format-align-left'
import IconToysfrom from 'material-ui/svg-icons/hardware/toys'
import IconSearch from 'material-ui/svg-icons/action/search'
import { cyan300, blue700, red500, orange200, green300, teal300, pink100, brown300 } from 'material-ui/styles/colors'

export const siteMap = [
  {
    title: 'Home',
    icon: <IconHome />,
    color: teal300,
    path: '/',
    authorization: 'home',
    navOnly: true,
    loggedIn: true
  },
  {
    title: 'Introduction',
    icon: <IconToysfrom />,
    color: orange200,
    path: 'http://corpus.ied.edu.hk/ace/About.html',
    authorization: 'intro',
    navOnly: false,
    loggedIn: true
  },
  {
    title: 'Browse Corpus',
    icon: <IconText />,
    color: green300,
    path: '/browse',
    authorization: 'browse',
    navOnly: false,
    loggedIn: true
  },
  {
    title: 'Search Corpus',
    icon: <IconSearch />,
    color: green300,
    path: 'http://corpus.ied.edu.hk/ace_search/',
    authorization: 'browse',
    navOnly: false,
    loggedIn: true
  }
]



// WEBPACK FOOTER //
// ./src/resources/siteMap.js